import { atom } from 'jotai'

export const selectedActiveOrderIdAtom = atom<number | null>(null)
selectedActiveOrderIdAtom.debugLabel = 'selectedActiveOrderIdAtom'
